import React, { useState } from 'react';
import './Modal.scss';
import { Modal } from 'antd';
import { Button } from '../Button';

type ButtonType = 'delete' | string;

export interface ModalProps {
  isOpen?: boolean; // Keep the management of "open" outside the modal.
  cancelFunction: Function;
  validateFunction: Function;
  title: string;
  children: string | JSX.Element | JSX.Element[]; //main content
  // footer?: JSX.Element[] | null, // if you don't want a footer, set it to null
  closeOnOutsideClick?: boolean; // default = false
  closeIcon?: boolean; // default = true
  width?: undefined | number; //default 700 (700px),
  loading?: boolean;
  buttonType?: ButtonType;
  disabled?: boolean;
  needCustomFooter?: () => JSX.Element;
}

export const ModalNooco = ({
  isOpen = true,
  cancelFunction,
  validateFunction,
  closeOnOutsideClick = false,
  closeIcon = true,
  title,
  children,
  width = 700,
  buttonType,
  loading = false,
  disabled = false,
  needCustomFooter,
}: ModalProps) => {
  const renderBasicFooterButtons = (buttonType: ButtonType) => {
    return (
      <>
        <div style={{ margin: '0.5rem 0.75rem', display: 'flex' }}>
          <Button
            className="close-button"
            onClick={() => cancelFunction()}
            text="Annuler"
          />
        </div>
        <div style={{ margin: '0.5rem 0.75rem', display: 'flex' }}>
          {buttonType === 'delete' ? (
            <Button
              className="delete-button"
              onClick={() => validateFunction()}
              loading={loading}
              disabled={disabled}
              text="Supprimer"
            />
          ) : (
            <Button
              className="purple-button"
              onClick={() => validateFunction()}
              loading={loading}
              disabled={disabled}
              text="Continuer"
            />
          )}
        </div>
      </>
    );
  };
  return (
    <Modal
      title={title}
      closable={closeIcon}
      open={isOpen}
      // footer={footer}
      footer={
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'flex-end',
          }}
        >
          {needCustomFooter
            ? needCustomFooter()
            : renderBasicFooterButtons(buttonType)}
        </div>
      }
      width={width}
      maskClosable={closeOnOutsideClick}
      onCancel={(e) => {
        cancelFunction();
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {children}
    </Modal>
    // <div>test</div>
  );
};
